import { NAMESPACE } from './constants';
import { OrderListState } from './reducers';

export const getFilter = (state: OrderListState): string => state[NAMESPACE].view.filter;
